import { render, staticRenderFns } from "./ContactDropdownItem.vue?vue&type=template&id=5d78737a&scoped=true"
import script from "./ContactDropdownItem.vue?vue&type=script&lang=js"
export * from "./ContactDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./ContactDropdownItem.vue?vue&type=style&index=0&id=5d78737a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78737a",
  null
  
)

export default component.exports